import { useQuery } from '@tanstack/react-query';

import { useCurrentScope } from '../../../shared/scope/useCurrentScope.js';

import {
  getHotLeadsQueryKey,
  listHotLeads,
  type ListHotLeadsFilters,
} from '../api/hot-leads.client.js';

export function useHotLeads(filters: ListHotLeadsFilters = {}) {
  const scope = useCurrentScope();
  const workspaceId = scope?.workspaceId ?? 'anonymous';

  return useQuery({
    queryKey: getHotLeadsQueryKey(workspaceId, filters.filter),
    queryFn: () => listHotLeads(filters),
    enabled: scope !== null,
  });
}
